// extracted by mini-css-extract-plugin
export default {"ns_container":"NSLayout_ns_container__76LAZ","ns_layout_main":"NSLayout_ns_layout_main__H00S8"};